import { TranslatableKey } from '@app/types/translatable.type';

/**
 * Key is a string we get from the backend for salary pay item names
 */
const PayrollSalaryItemNamesDisplayOptions: { [key: string]: TranslatableKey } = {
    'Regular Pay': 'payroll.salaryItemNames.regularPay',
    // Add other salary item names as needed
};

export { PayrollSalaryItemNamesDisplayOptions };
